import React, { Component } from 'react';

class CustomSelect extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isActive: false,
            selectedOption: '',
            filter: '',
            rawColumns: this.props.availableColumns,
            selects: this.props.selectedColumns,
            fileHeaders: this.props.fileHeaders,
            disabled: false
		}
	}

    componentDidMount() {
        document.addEventListener('click', this.closeElement, true);
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.closeElement, true);
    }

    componentWillReceiveProps(newProps) {
        if(newProps.autoMap) {
            this.autoMap();
        }
    }

    toggleView = () => {
        if(this.state.disabled) {
            return false;
        } else {
            if(this.state.isActive) {
                return false;
            } else {
                this.setState({
                    isActive: true
                });
            }
        }
    }

    closeElement = () => {
        this.setState({
            isActive: false,
        });
    }

    selectOption = (opt) => {
        this.setState({
            selectedOption: opt
        }, function() {
            this.closeElement();
            this.props.onChange(this.props.id, this.state.selectedOption);
        });
    }

    eachOption = (res, i) => {
        var selects = Object.values(this.state.selects);
        if(selects.indexOf(res) === -1) {
            return(
                <li
                    key={i}
                    onClick={() => this.selectOption(res)}
                    style={{backgroundColor: (i % 2 === 0 ? '#FAFAFA' : '#FFFFFF')}}
                    className={'anim1 br5'}
                >
                    {res}
                </li>
            );
        }
    }

    autoMap = () => {
        this.setState({
            disabled: true
        }, function() {
            var id = this.props.id;
            id = id.split("_____")[0];
            var columns = Object.values(this.state.rawColumns);
            if(columns.indexOf(id) !== -1) {
                this.selectOption(id);
            } else {
                this.selectOption("ignorecolumn!!");
            }
            this.setState({
                disabled: false
            }, function() {
                this.props.endAutoMap();
            });
        });
    }

    onChangeFilter = (event) => {
        this.setState({
            [event.target.name]: event.target.value
        });
    }

    render() {
        let options = this.state.rawColumns.filter(
            (option) => {
                return option.toLowerCase().indexOf(this.state.filter.toLowerCase()) !== -1;
            }
        );
    	return(
    		<div className={'customSelect' + (this.state.isActive ? ' active' : '')} onClick={this.toggleView}>
    			{this.state.selectedOption === 'ignorecolumn!!' ? '- - Ignore - -' : this.state.selectedOption === '' ? 'Select an option' : this.state.selectedOption}
                <input type="text" name="filter" placeholder="Search" value={this.state.filter} onChange={this.onChangeFilter} />
                <div className="line"></div>
                <ul className="options" ref="options">
                    <li onClick={() => this.selectOption("ignorecolumn!!")} className={'anim1 br5'}>- - Ignore - -</li>
                    {options.map(this.eachOption)}
                </ul>
    		</div>
    	);
    }
}

export default CustomSelect;


// WEBPACK FOOTER //
// ./src/components/elements/CustomSelect.js